// extracted by mini-css-extract-plugin
module.exports = {"jobPositions":"TeamsJobPositions_jobPositions__5hXgl","jobPositions__image":"TeamsJobPositions_jobPositions__image__uDNPD"};